import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import MainHeader from "../components/MainHeader";
import { elsevierStyleSheetJSfileImport } from "../library/utils";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import CartElement from "../components/CartElement";
import { calculateDiscountAmount } from "../library/utils";
import EmptyCart from "../components/EmptyCart";
import CartElementMobile from "../components/CartElementMobile";
import { Link, useNavigate } from "react-router-dom";

const ShoppingCart = () => {
  const [cartProducts, setCartProducts] = useState([]);
  const [cartUpdated, setCartUpdated] = useState(false);
  const [auth, setAuth] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    fetchCartDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCartDetails = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const config = {
      method: 'post',
      url: `${backendBookartUrl}/view_cart_details`,
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    };
    axios(config)
      .then(response => {
        const cartProducts = response.data.cart_details;
        setCartProducts(cartProducts);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const deleteCartItem = (cartId, productId) => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      cart_id: cartId,
      product_id: productId,
    });

    const config = {
      method: "post",
      url: `${backendBookartUrl}/remove_cart_details?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(response => {
        const cartProducts = response.data.cart_details;
        setCartProducts(cartProducts);
        setCartUpdated(true);
        fetchCartDetails();
        setTimeout(() => setCartUpdated(false), 1000); // Reset cartUpdated after 1 second
      })
      .catch(error => {
        console.log(error);
      });
  };

  const updateCartDetails = (product) => {
    console.log("Updating cart details for:", product);
    const { cart_id, product_id, quantity, total_price, discount_percentage } = product;
    const discount_price = calculateDiscountAmount(total_price, discount_percentage);
    const subtotal = quantity * (total_price - discount_price);
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      product_id: product_id,
      quantity: quantity,
      subtotal: subtotal,
      cart_id: cart_id
    });

    const config = {
      method: "post",
      url: `${backendBookartUrl}/update_cart_details?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(response => {
        const cartProducts = response.data.cart_details;
        setCartProducts(cartProducts);
        setCartUpdated(true);
        fetchCartDetails();
        setTimeout(() => setCartUpdated(false), 1000); // Reset cartUpdated after 1 second
      })
      .catch(error => {
        console.log(error);
      });
  };


  const handleContinueShopping = () => {
    navigate("/list"); // Navigate to the /list route
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
      //} else {
      //  const valid = await validateJWTtoken(token);
      //  if (!valid) {
      //    navigate("/");
    } else {
      setAuth(true);
    }
    //}
  };

  if (!auth) {
    return <div></div>; // Optionally, you can show a loading indicator here
  }

  return (
    <React.Fragment>
      <MainHeader cartUpdated={cartUpdated} fetchCartAfterModifying={fetchCartDetails} />
      <section className="container">
        <div id="shopping-cart">
          <button onClick={handleContinueShopping} className="es-link colored font-16" style={{ cursor: 'pointer' }}>
            <svg viewBox="0 0 54 128" height="16" width="11">
              <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
            </svg>
            &nbsp;Continue shopping
          </button>
          <div id="cart-items-details">
            <span className="font-36">Shopping Cart</span>&nbsp; &nbsp;
            <span className="font-24">{cartProducts.length} items</span>
          </div>
          {cartProducts.length !== 0 ? (
            <div>
              <hr />
              <div className="margin-bottom-40p mobile-none">
                {cartProducts.map(element => (
                  <CartElementMobile
                    key={element.cart_id}
                    id={element.cart_id}
                    data={element}
                    deleteCartItem={deleteCartItem}
                    updateCartItem={updateCartDetails}
                  />
                ))}
                <div className="grand-total-mobile">
                  <p className="margin-right-20p">
                    Cart total ({cartProducts.length} items)
                  </p>
                  <strong className="font-size-22">₹&nbsp;
                    {cartProducts.reduce((sum, element) => sum + element.subtotal, 0)}
                  </strong>
                </div>
                <hr />
                <Link to="/checkout" className="es-button primary large text-center w-100">
                  <span>Proceed To Checkout</span>
                  <svg focusable="false" height="24" viewBox="0 0 54 128" width="11">
                    <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                  </svg>
                </Link>
              </div>

              <div className="row cart-data">
                <div className="col-md-8 cart-details">
                  <table className="table table-borderless cart-table">
                    <thead className='cart-table-header'>
                      <tr>
                        <td>Products</td>
                        <td>Price</td>
                        <td>Discount</td>
                        <td>Qty</td>
                        <td>Subtotal</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {cartProducts.map(element => (
                        <CartElement
                          key={element.cart_id}
                          id={element.cart_id}
                          data={element}
                          deleteCartItem={deleteCartItem}
                          updateCartItem={updateCartDetails}
                        />
                      ))}
                      <tr className='cart-grand-total'>
                        <td className="font-16"><strong>Grand Total</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="font-24">₹&nbsp;{cartProducts.reduce((sum, element) => sum + element.subtotal, 0)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-4 cart-total">
                  <div className="border order-summary">
                    <table className="table table-borderless">
                      <tbody className="font-16">
                        <tr>
                          <td>Cart total ({cartProducts.length} items)</td>
                          <td>
                            <strong>₹&nbsp;
                              {cartProducts.reduce((sum, element) => sum + element.total_price * element.quantity, 0)}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Discount total ({cartProducts.length} items)</td>
                          <td>
                            <strong>₹&nbsp;
                              {cartProducts.reduce((discount, element) => discount + (element.discount_price * element.quantity), 0)}
                            </strong>
                          </td>
                        </tr>
                        <tr className='order-summary-grand-total'>
                          <td>Grand total ({cartProducts.length} items
                          </td>
                          <td>
                            <strong>₹&nbsp;
                              {cartProducts.reduce((sum, element) => sum + element.subtotal, 0)}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <Link to="/checkout" className="es-button primary large text-center w-100">
                      <span>Confirm Address</span>
                      <svg focusable="false" height="24" viewBox="0 0 54 128" width="11">
                        <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <EmptyCart />
          )}
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default ShoppingCart;